// extracted by mini-css-extract-plugin
export var MainContainer = "MainContainer-module--MainContainer--b27b5";